import React from 'react';

export default () => {
  return (
    <div className="step row">
      {/*Pregunta 9*/}
      <div className="col-md-12">
        <h3>9. ¿Existe exceso de burocracia en mi trabajo?</h3>
        <ul className="data-list-2" id="preg9">
          <li>
            <input
              name="preg9"
              type="radio"
              className="required check_radio"
              value="2"
            />
            <label>Totalmente De acuerdo</label>
          </li>
          <li>
            <input
              name="preg9"
              type="radio"
              className="required check_radio"
              value="1"
            />
            <label>De acuerdo</label>
          </li>
          <li>
            <input
              name="preg9"
              type="radio"
              className="required check_radio"
              value="0"
            />
            <label>Ni de acuerdo ni en desacuerdo</label>
          </li>
          <li>
            <input
              name="preg9"
              type="radio"
              className="required check_radio"
              value="0"
            />
            <label>En desacuerdo</label>
          </li>
          <li>
            <input
              name="preg9"
              type="radio"
              className="required check_radio"
              value="0"
            />
            <label>Totalmente desacuerdo</label>
          </li>
        </ul>
      </div>
      {/*Pregunta 10*/}
      <div className="col-md-12">
        <h3>10. ¿Me siento feliz estando en el trabajo?</h3>
        <ul className="data-list-2" id="preg10">
          <li>
            <input
              name="preg10"
              type="radio"
              className="required check_radio"
              value="2"
            />
            <label>Totalmente De acuerdo</label>
          </li>
          <li>
            <input
              name="preg10"
              type="radio"
              className="required check_radio"
              value="1"
            />
            <label>De acuerdo</label>
          </li>
          <li>
            <input
              name="preg10"
              type="radio"
              className="required check_radio"
              value="0"
            />
            <label>Ni de acuerdo ni en desacuerdo</label>
          </li>
          <li>
            <input
              name="preg10"
              type="radio"
              className="required check_radio"
              value="0"
            />
            <label>En desacuerdo</label>
          </li>
          <li>
            <input
              name="preg10"
              type="radio"
              className="required check_radio"
              value="0"
            />
            <label>Totalmente desacuerdo</label>
          </li>
        </ul>
      </div>
      {/*Pregunta 11*/}
      <div className="col-md-12">
        <h3>11. ¿Mi salud en general es buena?</h3>
        <ul className="data-list-2" id="preg11">
          <li>
            <input
              name="preg11"
              type="radio"
              className="required check_radio"
              value="2"
            />
            <label>Totalmente De acuerdo</label>
          </li>
          <li>
            <input
              name="preg11"
              type="radio"
              className="required check_radio"
              value="1"
            />
            <label>De acuerdo</label>
          </li>
          <li>
            <input
              name="preg11"
              type="radio"
              className="required check_radio"
              value="0"
            />
            <label>Ni de acuerdo ni en desacuerdo</label>
          </li>
          <li>
            <input
              name="preg11"
              type="radio"
              className="required check_radio"
              value="0"
            />
            <label>En desacuerdo</label>
          </li>
          <li>
            <input
              name="preg11"
              type="radio"
              className="required check_radio"
              value="0"
            />
            <label>Totalmente desacuerdo</label>
          </li>
        </ul>
      </div>
      {/*Pregunta 12*/}
      <div className="col-md-12">
        <h3>12. ¿Me siento lleno de energía?</h3>
        <ul className="data-list-2" id="preg12">
          <li>
            <input
              name="preg12"
              type="radio"
              className="required check_radio"
              value="2"
            />
            <label>Totalmente De acuerdo</label>
          </li>
          <li>
            <input
              name="preg12"
              type="radio"
              className="required check_radio"
              value="1"
            />
            <label>De acuerdo</label>
          </li>
          <li>
            <input
              name="preg12"
              type="radio"
              className="required check_radio"
              value="0"
            />
            <label>Ni de acuerdo ni en desacuerdo</label>
          </li>
          <li>
            <input
              name="preg12"
              type="radio"
              className="required check_radio"
              value="0"
            />
            <label>En desacuerdo</label>
          </li>
          <li>
            <input
              name="preg12"
              type="radio"
              className="required check_radio"
              value="0"
            />
            <label>Totalmente desacuerdo</label>
          </li>
        </ul>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/pages/survey/questions/Step3.jsx